<template>
    <div>
        <Dialog v-model:visible="visible" modal :header="header" :style="{ width: '50rem' }" @hide="emit('hide-dialog', true)">
            <DataTable :value="usersList" tableStyle="min-width: 50rem" :loading="loading">
                <Column field="id" header="ID" />
                <Column field="name" header="FIRSTNAME" />
                <Column field="surname" header="LASTNAME" />
                <Column field="email" header="EMAIL" />
            </DataTable>
        </Dialog>
    </div>
</template>

<script setup>
import { ref, onMounted, defineProps, defineEmits } from 'vue';

import { useStaticDashboardStore } from '../store/staticDashboard';

const emit = defineEmits(['hide-dialog']);

const props = defineProps({
    userGroupId: {
        type: Number,
        required: true,
    },
    header: {
        type: String,
        required: true,
    },
});
//
const store = useStaticDashboardStore();

// States
const visible = ref(true);
const loading = ref(false);
const usersList = ref([]);

onMounted(() => {
    // load user group results
    loadUsersList();
});

const loadUsersList = async () => {
    try {
        loading.value = true;
        usersList.value = await store.getUserGroupData(props.userGroupId);
    } catch (error) {
        console.error('Failed to load user group data');
    } finally {
        loading.value = false;
    }
};
</script>
